import { writableSessionStorage } from './writableSessionStorage';

export interface IEventFilterOptionsStore {
	locations: string[];
	topics: string[];
	eventTypes: string[];
	targetGroups: string[];
}

const initFilterData: IEventFilterOptionsStore = {
	locations: [],
	topics: [],
	eventTypes: [],
	targetGroups: []
};

const createEventFilterOptionsStore = () => {
	const { subscribe, set, update } = writableSessionStorage(
		'eventFilterOptionsStore',
		initFilterData
	);

	return {
		subscribe,
		set,
		update
	};
};

export const eventFilterOptions = createEventFilterOptionsStore();
